import React, { useContext, useState } from "react";
import { CommonTable, CommonTabList } from "../common";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Col,
  Div,
  H6,
  Paper,
  Row,
  TextArea,
  TextInput,
} from "qdm-component-library";
import { SelectBox } from "../common/smartForm/component";
import {
  Button,
  Dialog,
  Grid,
  IconButton,
  makeStyles,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  Checkbox,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  RadioGroup,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {
  AlertProps,
  AxiosCall,
  extractIdAndValue,
  factoperatorlist,
  facttypelist,
} from "../../utils";
import { AlertContext, EnvContext } from "../../contexts";
import Config from "../../config";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";

const styles = {
  labelStyle: {
    color: "#6F6F6F",
    fontSize: "12px",
    marginBottom: "6px",
    fontFamily: `pc_regular !important`,
  },
  borderStyle: {
    borderRadius: 8,
    borderColor: "#E0E0E0",
  },
  errorBorderStyle: {
    borderRadius: 8,
    border: "1px solid red",
  },
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  addBtn: {
    float: "right",
    fontSize: "14px",
    fontWeight: 600,
  },
  content: {
    width: "100%",
    height: "calc(100vh - 64px)",
    overflow: "auto",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 56,
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
    },
    //   marginTop:"60px",
    //   marginLeft:"10px",
  },
  topNavbar: {},
  sideNavbar: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hovarNavBar: {
    display: "flex",
    position: "relative",
    top: "63px",
  },
}));

export const ServiceTypeConfig = (props) => {
  const headerList = {
    allHeaders: [
      "S.No",
      "Services",
      "Color",
      "Sequence",
      !props?.isFormOpen.isView && "Action",
    ],
  };
  const alert = useContext(AlertContext);
  const { envConfig } = useContext(EnvContext);
  const classes = useStyles({ props });
  const { labelStyle, borderStyle, errorBorderStyle } = styles;

  // ---------state------------

  const [addNew, setAddNew] = React.useState(false);
  const [warningAlert, setwarningAlert] = useState();
  const [state, setState] = React.useState({
    _id: "",
    servicecode: "",
    servicetype: "",
    serviceDetails: [],
    isclinical: "",
  });
  const [error, setError] = React.useState(false);
  const [facttypeError, setFacttypeError] = React.useState(false);
  const [showtypes, setshowtypes] = React.useState(false);
  const [addservice, setaddservice] = React.useState({
    services: "",
    color: "",
    sequence: null,
    index: null,
  });
  const [factEditIndex, setFactEditIndex] = React.useState(null);
  const [factError, setFactError] = React.useState(false);
  const [collectionList, setCollectionList] = React.useState([]);
  const [generalMaster, setGeneralMaster] = React.useState([]);
  const [fieldList, setFieldList] = React.useState([]);
  const [operator, setOperator] = useState([]);
  // const [factTypeshow, setFactTypeshow] = useState([]);

  // ----------events-----------

  const handleFormState = (key, value) => {
    setState({
      ...state,
      [key]: value,
    });
  };
  const handleChange = (key, value) => {
    setaddservice({
      ...addservice,
      [key]: value,
    });
  };

  const clearAllNotificationTypes = () => {
    setState({
      ...state,
      serviceDetails: [],
    });
    setaddservice({
      services: "",
      color: "",
      sequence: null,
    });
    setwarningAlert(false);
  };

  const setaddfunction = () => {
    // setFacttypeError(true);
    // if (!state?.facttype?.value) {
    //   alert?.setSnack({
    //     open: true,
    //     severity: AlertProps.severity.error,
    //     msg: "Please select the fact type field",
    //     vertical: AlertProps.vertical.top,
    //     horizontal: AlertProps.horizontal.right,
    //     tone: true,
    //   });
    //   return;
    // }
    setAddNew(true);
    clearFacts();
  };
  const getGeneralMaster = async () => {
    try {
      let payload = {
        db_name: envConfig.REACT_APP_DATABASE_NAME,
        filter: {
          type: ["LEADSERVICETYPE", "SERVICETYPE"],
          tenantid: envConfig.REACT_APP_TENANTID,
          facilityid: "",
          lang: "en",
        },
        queryid: envConfig.REACT_APP_RULE_BUILDER_FACT_GM,
      };
      let Resp = await AxiosCall(
        payload,
        envConfig.REACT_APP_READ_QDM_QUERY
      );
      if (Resp) {
        setGeneralMaster(Resp);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const saveFacts = () => {
    setFactError(true);
    if (
      !addservice?.services?.value ||
      !addservice?.color ||
      !addservice?.sequence
    ) {
      alert?.setSnack({
        open: true,
        severity: AlertProps.severity.error,
        msg: "Please fill all the mandatory fields!",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.right,
        tone: true,
      });
      return;
    }
    if (
      Number(addservice.sequence) < 1 ||
      isNaN(Number(addservice?.sequence))
    ) {
      alert?.setSnack({
        open: true,
        severity: AlertProps.severity.error,
        msg: "Sequence Must be a Number Eg: 1,2!",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.right,
        tone: true,
      });
      return;
    }
    let seq = Number(addservice?.sequence);
    if (!String(factEditIndex)) {
      if (
        state?.serviceDetails?.some(
          (item) =>
            (item?.services?._id === addservice?.services?._id &&
              item?.color === addservice?.color) ||
            item?.sequence === addservice?.sequence
        )
      ) {
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Service Details Already Exist",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
        return;
      }
      // else {
      //    let list = [...state?.serviceDetails];
      //    list[factEditIndex] = addservice;
      //    handleFormState("serviceDetails", list);
      // }
    } else {
      if (
        state?.serviceDetails?.filter(
          (item, i) =>
            ((item?.services?._id === addservice?.services?._id &&
              item?.color === addservice?.color) ||
              item?.sequence == addservice?.sequence) &&
            i !== factEditIndex
        ).length > 0
      ) {
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Service Details Already Exist",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
        return;
      }
      // else {
      //    let list = [...state?.serviceDetails];
      //    list.push(addservice);
      //    handleFormState("serviceDetails", list);
      // }
    }
    setFactError(false);
    if (factEditIndex == null) {
      let list = [...state?.serviceDetails];
      list.push(addservice);
      handleFormState("serviceDetails", list);
    } else {
      let list = [...state?.serviceDetails];
      list[factEditIndex] = addservice;
      handleFormState("serviceDetails", list);
    }
    clearFacts();
    setAddNew(false);
    setFactEditIndex(null);
  };
  const clearFacts = () => {
    setFactError(false);
    setaddservice({
      services: "",
      color: "",
      sequence: "",
    });
  };
  const handleSubmit = async () => {
    setError(true);
    if (
      //   !state?.servicecode ||
      !state?.servicetype ||
      !state?.isclinical ||
      !state?.serviceDetails?.length > 0
    ) {
      if (!state?.servicecode || !state?.servicetype || !state?.isclinical) {
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Please fill all the mandatory fields!",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
      } else {
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Please fill at leat one Service Details!",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
      }
    } else {
      setError(false);
      let constructServDetails = [];
      state?.serviceDetails?.map((v, i) => {
        let obj = {
          services: v?.services?._id,
          color: v?.color,
          sequence: Number(v?.sequence),
        };
        constructServDetails.push(obj);
      });
      let payload = {
        servicecode: state?.servicecode ?? "",
        servicename: state?.servicetype,
        isclinicalassment: state?.isclinical === "yes" ? true : false,
        servicedtls: constructServDetails,
      };
      let filter = { filter: { _id: state?._id ? state?._id : "" } };
      let masterPayload = [];
      let data = state?.servicecode
        ? {
            db_name: envConfig.REACT_APP_DATABASE_NAME,
            entity: Config.LeadServiceTypeConfig,
            is_metadata: true,
            metadataId: envConfig.REACT_APP_METADATAID,
            metadata_dbname: envConfig.REACT_APP_MetadataDB_Name,
            ...filter,
            doc: payload,
          }
        : {
            db_name: envConfig.REACT_APP_DATABASE_NAME,
            entity: Config.LeadServiceTypeConfig,
            is_metadata: true,
            metadataId: envConfig.REACT_APP_METADATAID,
            metadata_dbname: envConfig.REACT_APP_MetadataDB_Name,
            // ...filter,
            doc: payload,
          };
      masterPayload.push(data);
      let Resp = await AxiosCall(
        masterPayload,
        envConfig.REACT_APP_UPSERT_DOC
      );
      if (Resp.Code === 201) {
        props?.getFacts();
        props?.setisFormOpen({
          isForm: false,
          isEdit: false,
          isView: false,
        });
        setState({
          _id: "",
          servicecode: "",
          servicetype: "",
          serviceDetails: [],
          isclinical: "",
        });
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.success,
          msg: state?.servicecode
            ? "Update Successfully"
            : "Saved Successfully!",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
      } else {
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Failed to Save!",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
      }
    }
  };
  const handleListEdit = (index) => {
    let getSingleFact = state?.serviceDetails[index];
    setAddNew(true);
    setFactEditIndex(index);
    setaddservice({
      services: getSingleFact?.services,
      color: getSingleFact?.color,
      sequence: getSingleFact?.sequence,
    });
  };
  const handleDelete = (e, data, index) => {
    let list = JSON.parse(JSON.stringify(state?.serviceDetails));
    list.splice(index, 1);
    setState({
      ...state,
      serviceDetails: list,
    });
  };
  const handleGoBack = () => {
    props?.getFacts();
    props?.setEditState({ edit: false, editState: {} });
    setState({
      _id: "",
      servicecode: "",
      servicetype: "",
      serviceDetails: [],
      isclinical: "",
    });
    props?.setisFormOpen({
      isForm: false,
      isEdit: false,
      isView: false,
    });
  };

  // -----------Life Cycles-----------

  //   React.useEffect(() => {
  //     getFieldName(fact?.collectionName?.value);
  //   }, [fact?.collectionName?._id]);

  React.useEffect(() => {
    getGeneralMaster();
  }, []);

  React.useEffect(() => {
    if (props?.editState?.edit) {
      const facts = props?.editState?.editState?.servicedtls;
      let constructFacts = [];
      facts?.map((v, i) => {
        let obj = {
          services: {
            _id: v?.services?._id ?? "",
            label: v?.services?.display ?? "",
            value: v?.services?.display ?? "",
          },
          color: v?.color ?? "",
          sequence: v?.sequence,
        };
        constructFacts.push(obj);
      });
      setState({
        _id: props?.editState?.editState?._id,
        servicecode: props?.editState?.editState?.servicecode,
        isclinical: props?.editState?.editState?.isclinicalassment
          ? "yes"
          : "no",
        // facttype: props?.editState?.editState?.facttype,
        servicetype: props?.editState?.editState?.servicename,
        // servicetype: {
        //   _id: props?.editState?.editState?.servicename?._id,
        //   label: props?.editState?.editState?.servicename?.display,
        //   value: props?.editState?.editState?.servicename?.display,
        // },
        serviceDetails: constructFacts,
      });
    }
  }, [props?.editState]);
  return (
    <div>
      <Div>
        <CommonTabList
          parent_id={"agerange_form"}
          backbtn
          backFun={handleGoBack}
          title={
            props?.isFormOpen?.isForm
              ? "Add New Service"
              : props?.isFormOpen?.isEdit
              ? "Edit Service"
              : "View Service"
          }
          list={[]}
        />
      </Div>
      <Div className="pi-paper">
        <Grid container spacing={2} direction="column">
          <Grid item>
            <Paper className="pi-paper">
              <Div>
                <H6 className="pi-title">{"Service Type Configuration"}</H6>
              </Div>
              <Row>
                <Col lg={4} inLineStyles={{ padding: 10 }}>
                  <TextInput
                    value={state?.servicecode}
                    onChange={(e) =>
                      handleFormState("servicecode", e.target.value)
                    }
                    label="Code"
                    labelStyle={labelStyle}
                    placeholder=""
                    style={borderStyle}
                    disabled
                  />
                </Col>
                <Col lg={4} inLineStyles={{ padding: 10 }}>
                  <TextInput
                    value={state?.servicetype}
                    onChange={(e) =>
                      handleFormState("servicetype", e.target.value)
                    }
                    label="Service Type"
                    error={
                      (error && !state?.servicetype) ||
                      (facttypeError && !state?.servicetype)
                    }
                    disabled={props?.isFormOpen?.isView}
                    labelStyle={labelStyle}
                    placeholder=""
                    style={borderStyle}
                  />
                  {/* <Typography
                    style={{
                      fontSize: "12px",
                      Fontfamily: "pc_regular",
                      color: "#6F6F6F",
                    }}
                    variant="body1"
                  >
                    Service Type<span style={{ color: "red" }}> *</span>
                  </Typography>
                  <SelectBox
                    // id={`${parent_id}-Workflow-selectBox`}
                    // list={factType}
                    list={extractIdAndValue("SERVICETYPE", generalMaster)}
                    value={state?.servicetype}
                    onchange={(e, v) => handleFormState("servicetype", v)}
                    labelStyle={labelStyle}
                    placeholder=""
                    error={
                      (error && !state?.servicetype?.value) ||
                      (facttypeError && !state?.servicetype?.value)
                    }
                    disabled={props?.isFormOpen?.isView}//props?.isFormOpen?.isEdit ||
                    // value={state?.facttype}
                    disableClearable
                    // error={error?.workflow}
                    // value={reftype?.workflow}
                    // disabled={isView ? true : false}
                    // onchange={(e, value) => handleFormState("workflow", value)}
                    // disabled={props?.isFormOpen?.isView}
                  /> */}
                </Col>
                <Col lg={4} inLineStyles={{ padding: 10 }}>
                  <Typography
                    style={{
                      fontSize: "12px",
                      Fontfamily: "pc_regular",
                      color: "#6F6F6F",
                    }}
                    variant="body1"
                  >
                    Is Clinical Assessment Requtied
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <FormControl
                    component="fieldset"
                    disabled={props?.isFormOpen?.isView}
                  >
                    <RadioGroup
                      row
                      value={state?.isclinical}
                      onChange={(e) =>
                        handleFormState("isclinical", e.target.value)
                      }
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio color="primary" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio color="primary" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Col>
              </Row>
            </Paper>
          </Grid>
          <Grid item>
            <Paper className="pi-paper">
              <Grid container justifyContent="space-between">
                <Grid item>
                  <Div>
                    <H6 className="pi-title">{"Service Details"}</H6>
                  </Div>
                </Grid>
                {!props?.isFormOpen?.isView && (
                  <Grid item>
                    <Div
                    //   onClick={() => setisNew(true)}
                    >
                      <Button
                        className={classes.addBtn}
                        onClick={() => {
                          // setAddNew(true);
                          // clearFacts();
                          setaddfunction();
                        }}
                        color="primary"
                      >
                        + Add New
                      </Button>
                    </Div>
                  </Grid>
                )}
              </Grid>

              {/**Rights Access Grid view */}
              <Grid container style={{ paddingTop: "10px" }}>
                <CommonTable
                  parent_id={"category_details"}
                  handleEdit={(e, data, index) => {
                    handleListEdit(index);
                  }}
                  handleDelete={handleDelete}
                  rightAlign={["Action"]}
                  Header={headerList?.allHeaders}
                  // dataList={state?.facts}
                  dataList={state?.serviceDetails}
                  tableData={[
                    { type: ["INCRIMENT"], name: "1" },
                    {
                      type: ["TEXT"],
                      name: "services",
                      optionLabel: "label",
                    },
                    { type: ["TEXT"], name: "color" },
                    { type: ["TEXT"], name: "sequence" },
                    // { type: ["TEXT"], name: "queryOrGm", optionLabel: "label" },

                    !props?.isFormOpen.isView && {
                      type: ["EDIT", "DELETE"],
                      name: "",
                      align: "right",
                    },
                  ]}
                  // condition={condition}
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid item>
            {!props?.isFormOpen?.isView && (
              <Paper className="pi-paper">
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <Button
                      onClick={() => {
                        props?.getFacts();
                        props?.setisFormOpen({
                          isForm: false,
                          isEdit: false,
                          isView: false,
                        });
                        // clearFacts();
                        setState({
                          _id: "",
                          servicecode: "",
                          servicetype: "",
                          serviceDetails: [],
                          isclinical: "",
                        });
                      }}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleSubmit()}
                    >
                      {props?.editState?.edit ? "Update" : "save"}
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            )}
          </Grid>
        </Grid>
      </Div>
      <Dialog
        open={addNew}
        maxWidth="lg"
        fullWidth
        onClose={() => setAddNew(false)}
        disableBackdropClick
      >
        <Paper className="pi-paper" style={{ padding: "30px 20px" }}>
          <Grid container justifyContent="space-between">
            <Grid item style={{ paddingLeft: "10px" }}>
              <Typography variant="h6">Add Service Details </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={() => setAddNew(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Row>
            <Col lg={4} inLineStyles={{ padding: 10 }}>
              <Typography
                style={{
                  fontSize: "12px",
                  Fontfamily: "pc_regular",
                  color: "#6F6F6F",
                }}
                variant="body1"
              >
                Services<span style={{ color: "red" }}> *</span>
              </Typography>
              <SelectBox
                list={extractIdAndValue("LEADSERVICETYPE", generalMaster)} //{collectionList ?? []}
                onchange={(e, v) => {
                  handleChange("services", v);
                }}
                placeholder={"select..."}
                error={factError && !addservice?.services?.value}
                // // disableClearable
                // disabled={
                //   props?.isFormOpen?.isView || props?.isFormOpen?.isEdit
                // }
                required={true}
                value={addservice?.services}
              />
            </Col>
            <Col lg={2} inLineStyles={{ padding: 10 }}>
              <Typography
                style={{
                  fontSize: "12px",
                  Fontfamily: "pc_regular",
                  color: "#6F6F6F",
                }}
                variant="body1"
              >
                Color<span style={{ color: "red" }}> *</span>
              </Typography>
              <input
                type="color"
                value={addservice?.color ?? ""}
                onChange={(e) => handleChange("color", e.target.value)}
                style={{
                  width: "40px",
                  height: "40px",
                  border: "none",
                  cursor: "pointer",
                  background: "none",
                  padding: 0,
                }}
              />
            </Col>
            <Col lg={4} inLineStyles={{ padding: 10 }}>
              <TextInput
                value={addservice?.sequence}
                onChange={(e) => handleChange("sequence", e.target.value)}
                label={
                  <>
                    Sequence<span style={{ color: "red" }}> *</span>
                  </>
                }
                labelStyle={labelStyle}
                placeholder=""
                style={
                  factError && !addservice?.sequence
                    ? errorBorderStyle
                    : borderStyle
                }
              />
            </Col>
          </Row>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button onClick={clearFacts}> Clear</Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" onClick={saveFacts}>
                Add
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Dialog>
      <Dialog
        open={warningAlert}
        keepMounted
        aria-labelledby="alert-title"
        aria-describedby="alert-description"
      >
        <DialogTitle id="alert-title">
          <Typography style={{ display: "flex" }}>
            <ErrorOutlineOutlinedIcon
              style={{
                width: 22,
                height: 32,
                marginRight: 7,
                color: "#F58B00",
              }}
            />
            <Typography
              variant="span"
              style={{ paddingTop: 5, fontWeight: "bold" }}
            >
              {"Warning"}
            </Typography>
          </Typography>
          <CloseIcon
            onClick={() => setwarningAlert(false)}
            style={{ float: "right", marginTop: "-26px", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-description"
            style={{ border: `1.5px solid "#F58B00"`, borderRadius: "8px" }}
          >
            <Typography
              style={{
                background: "#FEF3E5",
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                padding: "8px 11px",
                color: "#F58B00",
                fontWeight: 800,
                minWidth: 500,
              }}
            >
              Message
            </Typography>
            <Typography style={{ padding: "10px 10px 15px 10px" }}>
              {
                "Changing the Fact Type will result in the loss of Facts List data. Please proceed carefully."
              }
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ padding: "5px 23px 17px", justifyContent: "flex-end" }}
        >
          <Button
            variant="contained"
            onClick={() => clearAllNotificationTypes()}
            style={{ color: "white", background: "#F58B00" }}
          >
            {"I Understand & Clear all"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
